// Pure utility helpers — no Node, no DOM, no platform APIs.
export { newId } from './id.js';
export { slugify, isReservedSlug, validateSlugFormat } from './slug.js';
export { assignUniqueSlug } from './slug-backfill.js';
/**
 * Format an integer centavo amount as PHP currency string.
 * @example formatPhp(50000) -> "₱500.00"
 */
export function formatPhp(centavos) {
    const pesos = centavos / 100;
    return `₱${pesos.toFixed(2)}`;
}
/**
 * Returns MM-DD format for birthday matching against birth_month_day field.
 */
export function toBirthMonthDay(month, day) {
    const m = String(month).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${m}-${d}`;
}
/**
 * Type-safe object key iteration.
 */
export function objectKeys(obj) {
    return Object.keys(obj);
}
/**
 * Narrows to never — useful in exhaustive switch statements.
 */
export function assertNever(value, context = 'value') {
    throw new Error(`Unexpected ${context}: ${JSON.stringify(value)}`);
}
//# sourceMappingURL=index.js.map